import {
  CostModel,
  Device,
  DomainSessionId,
  DomainUserId,
  HealthcareSessionId,
  HealthcareUserId,
  Integer,
  NonEmptyText,
  Placement,
  ProductType,
  Url,
  USAStateAcronym,
  UUID,
  ZipCode,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const AdImpressionDef = UUID;

export type AdImpression = z.infer<typeof AdImpressionDef>;

export const PushAdClickDataDtoDef = z.object({
  id: NonEmptyText,
  advertiserId: Integer.optional(),
  advertiserName: NonEmptyText,
  displayUrl: z.string(),
  link: Url,
  dealType: CostModel,
  cpc: z.number(),
  adsSource: z.enum(['FeaturedAds', 'AdButler', 'MediaAlpha']).optional(),
  clickCount: z.number(),
  impressionId: AdImpressionDef,
  blockPosition: z.number(),
  pagePosition: z.number(),
  device: Device.optional(),
  placement: Placement,
  productType: ProductType,
  sessionId: HealthcareSessionId,
  stateAcronym: USAStateAcronym,
  zipCode: ZipCode,
  domainUserId: DomainUserId.optional(),
  domainSessionId: DomainSessionId.optional(),
  userId: HealthcareUserId,
  clickPlatform: z.string(),
  clickId: z.string(),
  clickTimestamp: z.string(),
});

export type PushAdClickDataDto = z.infer<typeof PushAdClickDataDtoDef>;
